module.exports = __webpack_public_path__ + "static/media/200Mbps.3db794a4.bin";